import React from "react";
import "./style.scss";
import Icon from "../Icon";
import { faClose } from "@fortawesome/free-solid-svg-icons";

type Tprop = {
    setShowDialog: any
    setCurrentState: any
    isCurrentState: boolean
    showDialog: boolean
}

export const BlockDialog: React.FC<Tprop> = ({ showDialog, setShowDialog, isCurrentState, setCurrentState }) => {
    return (
        <div className="blocking-confirmation-dialog">
            <div className="blocking-confirmation">
                <p>
                    Do you really want to {"block"} <br /> Hero "David Cooper" ?
                </p>
                <div className="closeIcon" onClick={() => {setShowDialog(false)}}>
                    <Icon icon={faClose} />
                </div>
                <div className="confirmation-buttons-wrapper">
                    <button onClick={() => {
                        setShowDialog(false)
                    }}>No</button>
                    <button onClick={() => {
                        setShowDialog(false)
                        setCurrentState(!isCurrentState)
                    }}>Yes</button>
                </div>
            </div>
        </div>
    )
}